"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const SocialTwitter = createSVGIcon(
  <path
    d="M6.858 16.114a11.6 11.6 0 0 1-4.132 2.075.857.857 0 0 0 0 1.611c11.863 4.869 19.406-2.657 18.257-11.006l1.92-3.977h-2.228c-2.777-3.411-10.149-3.24-8.932 4.029 0 0-3.943.703-8.983-4.252a.857.857 0 0 0-1.457.549 9.46 9.46 0 0 0 5.555 10.971Z"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "SocialTwitter",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      id: "5yLrJV",
      defaultMessage: "Twitter",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    className: legacyIconCls(),
  })
);
